export const getMatchesFromQuestion = (
  question: string
): string[][] | undefined => {
  if (!question || question.length === 0) return

  const questionMatches = question.match(/(\{=[^\}]+\})/g)

  if (!questionMatches) return

  return questionMatches.map((match) =>
    match
      .substring(1, match.length - 1)
      .split('=')
      .filter((item) => item.length > 0)
      .map((item) => item.trim())
  )
}
